var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadCustomField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-144 -48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-target",
    transform: "translate(144 48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-144 -48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m148.041 63c.482-5.826 5.133-10.477 10.959-10.959v-2.041h2v2.041c5.826.482 10.477 5.133 10.959 10.959h2.041v2h-2.041c-.482 5.826-5.133 10.477-10.959 10.959v2.041h-2v-2.041c-5.826-.482-10.477-5.133-10.959-10.959h-2.041v-2zm11.959-9c-5.519 0-10 4.481-10 10s4.481 10 10 10 10-4.481 10-10-4.481-10-10-10zm0 2c1.656 0 3 1.344 3 3s-1.344 3-3 3-3-1.344-3-3 1.344-3 3-3zm0 2c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zm6 12h-12v-1.2c0-3.203 2.597-5.8 5.8-5.8h.4c3.203 0 5.8 2.597 5.8 5.8zm-9.916-2h7.832c-.368-1.715-1.892-3-3.716-3h-.4c-1.824 0-3.348 1.285-3.716 3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadCustomField);
export default __webpack_public_path__ + "static/media/lead-custom-field.c6379906746471dcfd94a235fffa60d6.svg";
export { ForwardRef as ReactComponent };